module.exports = "/assets/07898fa368f7283cdb5b9ad14f0d35b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/4M.png
// module id = 2169
// module chunks = 0